import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import EmailStatus from './EmailStatus';
import formService from '../services/formService';
import { validateContactForm, sanitizeFormData } from '../utils/formValidation';

const FormComponent = ({ onClose = () => {} }) => {
  console.log('📞 CONTACT FORM COMPONENT LOADED');
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    postcode: '',
    message: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    
    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setIsSubmitting(true);
    setSubmitStatus(null);

    // Validate form data
    const validationErrors = validateContactForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setIsSubmitting(false);
      return;
    }

    try {
      // Sanitize form data
      const sanitizedData = sanitizeFormData(formData);
      console.log('Contact form - Original form data:', formData);
      console.log('Contact form - Sanitized form data:', sanitizedData);
      
      // Submit form using service
      console.log('📞 CONTACT FORM: About to submit with data:', sanitizedData);
      const result = await formService.submitContactForm(sanitizedData);
      console.log('📞 CONTACT FORM: Form submitted successfully:', result);
      
      setSubmitStatus('success');
      setFormData({ name: '', phone: '', email: '', postcode: '', message: '' }); // Reset all fields
    } catch (error) {
      setSubmitStatus('error');
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = (e) => {
    e.preventDefault();
    onClose();
  };

  const modalContent = (
    <div className="fixed z-20 top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50">
      <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-lg relative max-w-md w-full">
        <button 
          onClick={handleClose} 
          type="button"
          className="absolute top-2 right-2 w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary hover:text-white transition-colors duration-200"
          aria-label="Close form"
        >
          ×
        </button>
        <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
        
        <EmailStatus
          status={submitStatus}
          message={
            submitStatus === 'success' 
              ? "Thank you for your message! We've sent you a confirmation email and will contact you soon."
              : submitStatus === 'error'
              ? "Something went wrong. Please try again or contact us directly at 07809 267586."
              : null
          }
          onClose={submitStatus ? () => setSubmitStatus(null) : null}
        />
        
        {['name', 'phone', 'email', 'postcode'].map((field) => (
          <div key={field} className="mb-4">
            <label htmlFor={field} className="block text-sm font-medium text-gray-700 capitalize">{field}</label>
            <input
              type={field === 'email' || field === 'recipientEmail' ? 'email' : 'text'}
              id={field}
              name={field}
              value={formData[field]}
              onChange={handleChange}
              className={`mt-1 p-2 border rounded w-full ${errors[field] ? 'border-red-500' : ''}`}
            />
            {errors[field] && <p className="text-red-500 text-xs mt-1">{errors[field]}</p>}
          </div>
        ))}
        
        <div className="mb-4">
          <label htmlFor="message" className="block text-sm font-medium text-gray-700">Message</label>
          <textarea
            id="message"
            name="message"
            rows="4"
            value={formData.message}
            onChange={handleChange}
            className={`mt-1 p-2 border rounded w-full ${errors.message ? 'border-red-500' : ''}`}
            placeholder="Tell us about your query or condition..."
          />
          {errors.message && <p className="text-red-500 text-xs mt-1">{errors.message}</p>}
        </div>
        <button
          type="submit"
          disabled={isSubmitting}
          className={`w-full font-bold text-white p-3 rounded-lg transition duration-300 ${
            isSubmitting ? 'bg-gray-400' : 'bg-primary hover:bg-secondary'
          }`}
        >
          {isSubmitting ? 'Submitting...' : 'Send Message'}
        </button>
      </form>
    </div>
  );

  return ReactDOM.createPortal(
    modalContent,
    document.body
  );
};export default FormComponent;